import { useEffect, useState } from "react";
import { getRoles } from "../services/accessControl.api";
import { useSelector } from "react-redux";

export default function useRoles() {

  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
  const fetchRoles = async () => {
    

    try {
      setLoading(true);
      const data = await getRoles(AppToken);
      setRoles(data);
    } catch (err) {
      console.error("Failed to load roles:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return {
    roles,
    loading,
    refreshRoles: fetchRoles
  };
}